









import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class ItSearch extends Vue {
  searchEvent() {
    this.$emit('search')
    this.$parent.$emit('search')
  }
}
